import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Tooltip, makeStyles } from '@material-ui/core';

import GetAppIcon from '@material-ui/icons/GetApp';

import RMSDownloadButton from 'components/RMSButtons/RMSDownloadButton';
import { downloadAttachment } from '../reducers/helpers/fileHelpers';
import { setCircularLoading } from '../reducers/ui/UiMenuReducer';

const useStyles = makeStyles((theme) => ({
  fabStyle: {
    backgroundColor: theme.palette.colors.chipBg,
    color: 'secondary',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

const DownloadAttachments = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { disabled = false, tooltipText = 'Download', children } = props;

  const selectedDownloadAttachments = useSelector(
    (state) => state.attachments.selectedDownloadAttachments
  );

  const handleMutipleDownload = async () => {
    dispatch(setCircularLoading(true));
    try {
      for (const att of selectedDownloadAttachments) {
        try {
          await downloadAttachment(att.ptsAttachmentId, att.name);
        } catch (err) {
          console.log('Download failed:', err);
        }
      }
    } finally {
      dispatch(setCircularLoading(false));
    }
  };

  return (
    <>
      <RMSDownloadButton
        disabled={disabled}
        tooltipText={tooltipText}
        className={classes.fabStyle}
        onClick={handleMutipleDownload}
      />
      {children}
    </>
  );
};

export default DownloadAttachments;
